module.exports = __webpack_public_path__ + "img/yobi.a80dd30c.svg";